
import {refreshToken} from "network/login.js"
import store from "../store"
import isMobile from './isMobile'


let refreshTokenF = function(){
    let type = ""
    if(isMobile()){
        type = "wx"
    }else{
        type = "pc"
    };
    refreshToken({
        openid:store.state.openid,
        type:type,
        refresh_token:store.state.refresh_token,
    }).then(res=>{
        if(res.code == 1){
            // console.log("微信token刷新成功")
        }
    })
}

export default refreshTokenF;